'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../../');

var _models = require('../../models');

require('./modal.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoModal = function (_Component) {
    _inherits(GeckoModal, _Component);

    function GeckoModal() {
        _classCallCheck(this, GeckoModal);

        return _possibleConstructorReturn(this, (GeckoModal.__proto__ || Object.getPrototypeOf(GeckoModal)).apply(this, arguments));
    }

    _createClass(GeckoModal, [{
        key: 'close',
        value: function close(evt) {
            if (evt.type === 'click' || evt.type === 'keydown' && [13].includes(evt.keyCode)) {
                return new _.GeckoModalService().close();
            }
        }
    }, {
        key: 'renderModalClose',
        value: function renderModalClose() {
            if (this.props.hideModalClose) return null;

            return _react2.default.createElement(
                'span',
                { tabindex: 0, className: 'modal-close', 'aria-label': 'Close', onClick: this.close.bind(this), onKeyDown: this.close.bind(this) },
                _react2.default.createElement(_.GeckoIcon, { icon: 'fa-times' })
            );
        }
    }, {
        key: 'renderHeader',
        value: function renderHeader() {
            if (this.props.name) {
                return _react2.default.createElement(
                    'div',
                    { className: 'modal-header' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'modal-title' },
                        this.props.name
                    ),
                    this.renderModalClose()
                );
            }
            return null;
        }
    }, {
        key: 'renderBody',
        value: function renderBody() {
            return _react2.default.createElement(
                'div',
                { className: 'modal-body clearfix' },
                this.props.children,
                this.renderFields()
            );
        }
    }, {
        key: 'renderFields',
        value: function renderFields() {
            if (this.props.fields.length) {
                return _react2.default.createElement(_.GeckoFields, { fields: this.props.fields, values: this.props.values, handler: this.props.handler.bind(this) });
            }
            return null;
        }
    }, {
        key: 'renderFooter',
        value: function renderFooter() {
            if (this.props.btns.length) {
                return _react2.default.createElement(
                    'div',
                    { className: 'modal-footer' },
                    _react2.default.createElement(_.GeckoBtnsSorted, { items: this.props.btns })
                );
            }
            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'gecko-ui-modal ' + this.props.className },
                this.renderHeader(),
                this.renderBody(),
                this.renderFooter()
            );
        }
    }]);

    return GeckoModal;
}(_react.Component);

GeckoModal.defaultProps = {
    className: '',
    fields: [],
    values: {},
    handler: function handler() {},
    submitHandler: function submitHandler() {},
    btns: [],
    hideModalClose: false
};

GeckoModal.propTypes = {
    name: _propTypes2.default.string,
    fields: _models.GeckoFieldsModel,
    values: _propTypes2.default.object,
    handler: _propTypes2.default.func,
    submitHandler: _propTypes2.default.func,
    btns: _models.GeckoBtnsModel,
    hideModalClose: _propTypes2.default.bool
};

exports.default = GeckoModal;